import script from "./OrderPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderPayment.vue?vue&type=script&setup=true&lang=js"

import "./OrderPayment.vue?vue&type=style&index=0&id=372f6a40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-372f6a40"]])

export default __exports__